import { LockFilled } from "@ant-design/icons";
import { Checkbox, Typography, Input } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./styles.less";

const AssetUnlockToggler = ({ id, placeholder, value }) => {
  const checked = `${value}` === "true";

  return (
    <div className="asset-toggler-container">
      <Input type="hidden" data-testid={id} value={value} />
      <div className="icon-container">
        <LockFilled className={classNames("element", "spacer")} />
      </div>
      <Typography.Text className="spacer">{placeholder}</Typography.Text>
      <Checkbox
        checked={checked}
        className={classNames("element", "app-checkbox-form-preview")}
        disabled={true}
      />
    </div>
  );
};

export default AssetUnlockToggler;

AssetUnlockToggler.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};
